import { eventRequest, workspaceActionsRequest } from '../../apiRequests'
import { getClaritySessionUrl, getCachedClarityInfo } from '../../../utils/clarityHelper'

export async function logEvent(eventType, eventData) {
    try {
        const params = {
            eventType,
            eventData, // Pass the actual object/array here
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        }

        const userID = localStorage.getItem('userID')
        const workspaceID = localStorage.getItem('workspaceID')
        const userName = localStorage.getItem('userName')

        if (userID) params.userID = userID
        if (workspaceID) params.workspaceID = workspaceID
        if (userName) params.email = userName

        const data = JSON.stringify(params)

        // Construct payload for Lambda
        const payload = {
            action: 'logEvent',
            data, // Send the encrypted string
        }

        // Send the payload to Lambda
        return await eventRequest(payload)
    } catch (error) {
        // Defensive logging - don't let logging errors break the app
        return null
    }
}

export const logError = async (message, stack) => {
    const params = {}
    const userID = localStorage.getItem('userID')
    const workspaceID = localStorage.getItem('workspaceID')
    const userName = localStorage.getItem('userName')
    const path = window.location.pathname
    if (userName) params.email = userName
    if (workspaceID) params.workspaceID = workspaceID
    if (path.includes('canvas/')) params.canvasID = path.split('/')[2]
    if (userID) params.userID = userID
    params.message = message

    // Get Clarity session URL
    let claritySessionUrl = null

    // First try to get cached info for immediate response
    const cachedClarity = getCachedClarityInfo()
    if (cachedClarity && cachedClarity.url) {
        claritySessionUrl = cachedClarity.url
    } else {
        // If not cached, try to get it with retry logic
        claritySessionUrl = await getClaritySessionUrl()
    }

    params.stack = stack
    params.claritySessionUrl = claritySessionUrl
    const data = JSON.stringify(params)
    const payload = { action: 'debug', data }
    return await workspaceActionsRequest(payload)
}
